import { z } from 'zod/v4';

/** --- ActionType --- */
export const actionTypeSchema = z.enum(['open-popup']);
export type ActionType = z.infer<typeof actionTypeSchema>;

/** --- PopupFlowData --- */
export const popupFlowDataSchema = z
  .object({
    url: z.string(),
    popupId: z.string(),
    monitorIntervalMs: z.number(),
    handshakeTimeoutMs: z.number(),
  })
  .catchall(z.any());
export type PopupFlowData = z.infer<typeof popupFlowDataSchema>;
